import React, { useContext, useEffect, useState } from "react";
import { Form, Checkbox } from "antd";
import { chiefComplaintsOptions } from "../../../Options/historyOptions";
import DynamicInputFields from "../../../../../blocks/FormItems/DynamicInputFields";

const ChiefComplaints = ({ context, form }) => {
  const { formData } = useContext(context);

  // Handle both nested (edit mode) and flat (voice mode) structure
  const chiefComplaintsData =
    formData?.history?.chief_complaints || formData?.chief_complaints;

  const [complaintOthers, setComplaintOthers] = useState(
    chiefComplaintsData?.includes("others")
  );

  useEffect(() => {
    // Check for "others" in both structures
    const complaints =
      formData?.history?.chief_complaints || formData?.chief_complaints;
    setComplaintOthers(complaints?.includes("others"));
  }, [formData]);

  const handleChiefComplaintsChange = (selectedOptions) => {
    const isOthersSelected = selectedOptions.includes("others");
    setComplaintOthers(isOthersSelected);
  };

  return (
    <>
      <Form.Item
        label="Chief Complaints"
        name="chief_complaints"
        getValueProps={(v) => ({
          value: Array.isArray(v) ? v : v != null && v !== "" ? [v] : [],
        })}
        normalize={(v) => {
          if (Array.isArray(v)) return v;
          if (v == null || v === "") return [];
          return [v];
        }}
      >
        <Checkbox.Group onChange={handleChiefComplaintsChange}>
          {chiefComplaintsOptions.map((option) => (
            <div
              key={option.value}
              style={{ minWidth: "220px", padding: "6px" }}
            >
              <Checkbox value={option.value}>{option.label}</Checkbox>
            </div>
          ))}
        </Checkbox.Group>
      </Form.Item>
      {complaintOthers && (
        <>
          <DynamicInputFields
            field_key={"chief_complaints_others"}
            form={form}
            inputStyle={{ maxWidth: 800 }}
          />
        </>
      )}
    </>
  );
};

export default ChiefComplaints;
